import { Box, BoxProps } from "@chakra-ui/react";
export const ChartLineIcon = ({ ...props }: BoxProps) => {
  return (
    <Box {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 3.59961V12.6663C2 13.0199 2.14048 13.359 2.39052 13.6091C2.64057 13.8591 2.97971 13.9996 3.33333 13.9996H14"
          stroke="#E0282F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.69636 7.12579L11.8656 4.86019C12.1323 4.66951 12.5025 4.8631 12.4982 5.19095L12.4068 12.0057C12.4039 12.2246 12.2257 12.4004 12.0069 12.4004H4.00156C3.78065 12.4004 3.60156 12.2213 3.60156 12.0004V9.56609C3.60156 9.45999 3.64371 9.35825 3.71873 9.28323L5.68461 7.31753C5.75963 7.24253 5.86136 7.20039 5.96744 7.20039H8.46374C8.54716 7.20039 8.6285 7.17431 8.69636 7.12579Z"
          fill="#E0282F"
        />
      </svg>
    </Box>
  );
};
